module.exports = __webpack_public_path__ + "img/full-caregogi-4.5f654fe5.jpg";